// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  // baseAPIUrl: 'https://learnfeedback.devbyopeneyes.com',
  // baseUrl: 'https://learnfeedback.devbyopeneyes.com/',
  //baseAPIUrl: 'https://learnfeedback.uatbyopeneyes.com',
  //baseUrl: 'https://learnfeedback.uatbyopeneyes.com/',
  baseAPIUrl: 'https://assessment.learnfeedback.com',
  baseUrl: 'https://assessment.learnfeedback.com/',

  env: 'dev'
};



// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2/src/environments/environment.ts